if (!customElements.get('product-color-thumbnails')) {
  customElements.define('product-color-thumbnails', class ProductColorThumbnails extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.valueLabel = this.closest('.product-form__input')?.querySelector('[data-color-thumbnail-current]');
      this.buttons = Array.from(this.querySelectorAll('[data-color-thumbnail-value]'));

      if (!this.select) return;

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.selectValue(button.dataset.colorThumbnailValue));
      });
      this.select.addEventListener('change', () => this.sync());
      this.sync();
    }

    selectValue(value) {
      if (this.select.value === value) return;

      this.select.value = value;
      this.sync();
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    sync() {
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.colorThumbnailValue === this.select.value));
      });
      if (this.valueLabel) this.valueLabel.textContent = this.select.value;
    }
  });
}

if (!customElements.get('product-size-options')) {
  customElements.define('product-size-options', class ProductSizeOptions extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.valueLabel = this.closest('.product-form__input')?.querySelector('[data-size-option-current]');
      this.buttons = Array.from(this.querySelectorAll('[data-size-option-value]'));

      if (!this.select) return;

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.selectValue(button.dataset.sizeOptionValue));
      });
      this.select.addEventListener('change', () => this.sync());
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.select, { childList: true, subtree: true, characterData: true });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    selectValue(value) {
      if (this.select.value === value) return;

      this.select.value = value;
      this.sync();
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    sync() {
      this.buttons.forEach((button) => {
        const option = Array.from(this.select.options).find((item) => item.value === button.dataset.sizeOptionValue);
        const unavailable = !option || option.textContent.trim() !== option.value;
        button.setAttribute('aria-pressed', String(button.dataset.sizeOptionValue === this.select.value));
        button.classList.toggle('is-unavailable', unavailable);
        button.disabled = unavailable;
      });
      if (this.valueLabel) this.valueLabel.textContent = this.select.value;
    }
  });
}
